import { useState } from "react";
import { Share2, Link2, Mail, Check } from "lucide-react";
import { toast } from "sonner";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

const enc = encodeURIComponent;
const DARK = "bg-[#0B2A4A] text-white hover:bg-[#147C88]";
const LIGHT = "border border-white/40 text-white hover:bg-white/10";

export function ShareButton({ link, title, label = "Share", light = false, testId = "share-btn" }) {
  const [copied, setCopied] = useState(false);
  const nets = [
    { id: "whatsapp", label: "WhatsApp", href: `https://wa.me/?text=${enc(`${title} ${link}`)}` },
    { id: "facebook", label: "Facebook", href: `https://www.facebook.com/sharer/sharer.php?u=${enc(link)}` },
    { id: "x", label: "X (Twitter)", href: `https://twitter.com/intent/tweet?text=${enc(title)}&url=${enc(link)}` },
  ];
  const mobile = typeof navigator.share === "function" && window.matchMedia("(pointer: coarse)").matches;

  const copy = async () => {
    await navigator.clipboard.writeText(link);
    setCopied(true); toast.success("Link copied");
    setTimeout(() => setCopied(false), 2000);
  };
  const btn = `inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-sm font-semibold transition-colors ${light ? LIGHT : DARK}`;

  if (mobile) {
    return <button type="button" className={btn} onClick={() => navigator.share({ title, url: link }).catch(() => {})} data-testid={testId}><Share2 className="h-4 w-4" /> {label}</button>;
  }
  const item = "flex items-center gap-2 rounded-lg px-3 py-2 text-sm text-[#0B2A4A] hover:bg-[#FAF6EE] transition-colors";
  return (
    <Popover>
      <PopoverTrigger asChild><button type="button" className={btn} data-testid={testId}><Share2 className="h-4 w-4" /> {label}</button></PopoverTrigger>
      <PopoverContent align="start" className="w-56 p-2 flex flex-col" data-testid={`${testId}-menu`}>
        {nets.map((n) => <a key={n.id} href={n.href} target="_blank" rel="noopener noreferrer" className={item} data-testid={`${testId}-${n.id}`}><Share2 className="h-4 w-4" /> {n.label}</a>)}
        <a href={`mailto:?subject=${enc(title)}&body=${enc(`${title}\n\n${link}`)}`} className={item} data-testid={`${testId}-email`}><Mail className="h-4 w-4" /> Email</a>
        <button type="button" onClick={copy} className={item} data-testid={`${testId}-copy-link`}>{copied ? <Check className="h-4 w-4" /> : <Link2 className="h-4 w-4" />} {copied ? "Copied" : "Copy link"}</button>
      </PopoverContent>
    </Popover>
  );
}

export function ShareArticle({ slug, title }) {
  return <ShareButton link={`${window.location.origin}/api/share/blog/${slug}`} title={title} label="Share article" testId="share-article-btn" />;
}

export function ShareCourse({ path, title }) {
  return <ShareButton link={`${window.location.origin}${path}`} title={title} label="Share course" light testId="share-course-btn" />;
}
